import React from 'react';
import { Modal } from '../../../../components';

import { closeBlack } from '../../../../assets/Base64Image';
import { BlackWarning } from '../../../../assets/svg-image/common';
import ColumnCenter from '../../../../components/Layout/ColumnCenter';
import RowCenter from '../../../../components/Layout/RowCenter';
import SquadBoldText from '../../../../components/Text/SquadBoldText';
import PingFangSemiBoldText from '../../../../components/Text/PingFangSemiBoldText';
import SquadRegularText from '../../../../components/Text/SquadRegularText';
import PingFangRegularText from '../../../../components/Text/PingFangRegularText';
import Button from '../../../../components/Button';
import SquadSemiBoldItalicText from '../../../../components/Text/SquadSemiBoldItalicText';
import { lang } from '../../../../lib/utils/utils';

const OnlineDeliveryWarningModal: React.FC<Props> = ({
  onClose,
}) => {
  return (
    <Modal
      style={{ width: 270, padding: 'unset', paddingBottom: '26px', borderRadius: 40 }}
    >
      {/* 图标 */}
      <RowCenter>
        <img src={BlackWarning} style={{ width: '72px', height: '71px', marginTop: '-35px' }} />
      </RowCenter>

      {/* 关闭图标 */}
      <div
        onClick={() => onClose()}
        style={{ padding: '10px', width: '30px', height: '30px', marginLeft: 'auto', marginRight: '10px', marginTop: '-20px' }}
      >
        <img src={closeBlack} style={{ width: 14, height: 14 }} />
      </div>

      <ColumnCenter style={{ marginTop: -10 }}>
        {
          lang(
            <SquadSemiBoldItalicText fontSize={16} width={240} lineHeight={21} textAlign={'center'}>
              Online delivery is no longer available.
            </SquadSemiBoldItalicText>,
            <PingFangSemiBoldText fontSize={16} width={240} lineHeight={23} textAlign={'center'}>
              线上配送服务已暂停使用。
            </PingFangSemiBoldText>
          )
        }
        {
          lang(
            <SquadRegularText marginTop={16} width={240} fontSize={16} lineHeight={21} textAlign={'center'}>
              <SquadSemiBoldItalicText fontSize={16} lineHeight={21} isSpan={true}>
                To complete your delivery, please download our Foodifox Drop-Off app
              </SquadSemiBoldItalicText>
              . You’ll gain access to rewards and tools to make completing deliveries easier!
            </SquadRegularText>,
            <PingFangRegularText marginTop={16} width={240} fontSize={16} lineHeight={23} textAlign={'center'}>
              <PingFangSemiBoldText fontSize={16} lineHeight={23} isSpan={true}>
                为保障您的配送权益
              </PingFangSemiBoldText>
              ，请下载Foodifox Drop-Off应用程序以完成后续配送流程。
            </PingFangRegularText>
          )
        }
      </ColumnCenter>

      <RowCenter style={{ marginTop: 25 }}>
        <Button
          width={214}
          height={52}
          backgroundColor={'#00B595'}
          borderRadius={50}
          boxShadow={'0px 22px 30px 0px rgba(0,181,149,0.05)'}
          onClick={() => {
            onClose();
          }}
        >
          {
            lang(
              <SquadBoldText fontSize={18} color={'#FFFFFF'}>
                Continue
              </SquadBoldText>,
              <PingFangSemiBoldText fontSize={18} color={'#FFFFFF'}>
                继续
              </PingFangSemiBoldText>
            )
          }
        </Button>
      </RowCenter>
    </Modal>
  );
};

export interface Props {
  onClose: () => void;
}

export default OnlineDeliveryWarningModal;
